import { PlanFamily } from 'src/types';
import styles from './OfferCardPrice.module.scss';
import { SVG_SIZE_S } from 'src/constants';
import { Tag } from '@phosphor-icons/react';
import { useOfferedMonths } from 'src/hooks/paymentHooks/useOfferedMonths';
import { useGetPriceLabel } from 'src/hooks';

export interface OfferCardPriceProps {
  planFamily: PlanFamily;
  planPrice?: number | string;
}

export const OfferCardPrice = ({
  planFamily,
  planPrice,
}: OfferCardPriceProps & { isActive?: boolean }) => {
  const isTeams = planFamily === PlanFamily.BUSINESS;
  const { months: offeredMonths } = useOfferedMonths({ context: 'accept' });
  const offerPriceLabel = 0;
  const { finalPriceLabel } = useGetPriceLabel({
    planFamily,
  });
  const planPriceLabel = planPrice || finalPriceLabel;

  return (
    <div className={styles.root}>
      <p className={styles.priceContainer}>
        <span className={styles.currentPrice}>
          <span className={styles.currentPriceTitle}>
            <span className={styles.currentPriceCurrency}>$</span>
            {offerPriceLabel}
            &nbsp;
          </span>

          <span className={styles.currentPriceSubtitle}>
            <span>{isTeams ? 'per seat ' : ''}/mo</span>
          </span>
        </span>
      </p>

      <p className={styles.descriptionRow}>
        <Tag size={SVG_SIZE_S} weight="fill" className={styles.icon} />
        <span className={styles.description}>
          for {offeredMonths} {offeredMonths === 1 ? 'month' : 'months'}, then $
          {planPriceLabel}/month
        </span>
      </p>
    </div>
  );
};
